import $ from 'jquery';
import * as d3 from 'd3';
import * as ss from 'simple-statistics';

function isitChartable(data){
  for (let d of data){
    if ((d.stickerPriceOnCampus || d.stickerPriceOffCampus) && d.netPrice){
        return true;
      };
  }
}

export function runData(datafile, metric_type, target, flags, level) {
  if (isNaN(flags)) {
    return;
  }

  var healthMetrics;


  healthMetrics = datafile.map(year => {
      // Determine most complete trend between on- and off-campus

      const thisYear = {
        'timescale': year.year,
        'metric': year[metric_type]
      }

      return thisYear;
  });


 // responsiveness
 let window_width = $(window).width();
 let fullWidth;
 let fullHeight;

 fullWidth = 240;

 const commas = d3.format(',');

 // set the dimensions and margins of the graph
 const margin = { top: 10, right: 25, bottom: 30, left: 35 };

 const width = fullWidth - margin.left - margin.right;
 const height = fullWidth/3.3;
        // || $('#sticker-price-chart').height() - margin.top - margin.bottom;

  // set the ranges
 const x = d3.scaleBand().rangeRound([0, width]).padding(1),
     y = d3.scaleLinear().rangeRound([height, 0]),
     z = d3.scaleOrdinal(['#036888','#D2392A','#D2392A','#D2392A']);

   z.domain(d3.keys(healthMetrics[0]).filter(function(key) {
     return key !== "timescale";
   }));

   const trends = z.domain().map(function(name) {
     return {
       name: name,
       values: healthMetrics.map(function(d) {
         return {
           timescale: d.timescale,
           value: +d[name]
         };
       })
     };
   });



 // define the line
 const line = d3.line()
   .x(function(d) { return x(d.timescale); })
   .y(function(d) { return y(d.value); });

 // scale the range of the priceData
 
 // nx.domain(datafile.map(d => d.timescale));

 // ny.domain([0, d3.max(trends, function(c) {
 //                               return d3.max(c.values, function(v) {return v.total;});
 //                             }) + 500
 //          ]).nice();

  const newTrends = trends.map((rate) => {
    rate.values = rate.values.filter(item => !(isNaN(item.value)));
    return rate;
  });

  x.domain(newTrends[0].values.map(d => d.timescale));
  
  y.domain([0, d3.max(newTrends, function(c) {
    return d3.max(c.values, function(v) {
      return v.value * 1.1;
    });
  })]);

  const x2 = d3.scaleLinear().rangeRound([0, width]);

  x2.domain([d3.min(newTrends, function(c) {
    return d3.min(c.values, function(v) {
      return +v.timescale.split("-")[1];
    });
  }),d3.max(newTrends, function(c) {
    return d3.max(c.values, function(v) {
      return +v.timescale.split("-")[1];
    });
  })]);

  healthMetrics = healthMetrics.filter(function(yr){
    if (metric_type == 'enrollment' || metric_type == 'retention')  {
          if (yr.timescale != '19-20') {
            return true;
          
        } else {
          return false
        }
      } else {
          if (yr.timescale != '19-20' && yr.timescale != '18-19') {
            return true;
          
        } else {
          return false
        }
      }
    }
  )

  newTrends[0].values = newTrends[0].values.filter(function(yr){
    if (metric_type == 'enrollment' || metric_type == 'retention')  {
          if (yr.timescale != '19-20') {
            return true;
          
        } else {
          return false
        }
      } else {
          if (yr.timescale != '19-20' && yr.timescale != '18-19') {
            return true;
          
        } else {
          return false
        }
      }
    }
  )

  const linearRegression = ss.linearRegression(healthMetrics.map(d => {
    const key = +d.timescale.split("-")[1]
    return [key, d.metric]
  }))

  const linearRegressionLine = ss.linearRegressionLine(linearRegression)

  var xaxis = d3.axisBottom()
                   .scale(x).tickValues(['09-10','19-20']).tickFormat((d)=>{
                    return "20" + d
                   }).tickSizeOuter(0);

  var yaxis = d3.axisLeft()
                   .scale(y).ticks(3).tickFormat((d)=>{
                    if (d == 0 && metric_type != 'retention') {
                      return d;
                    } else {
                      if (metric_type == 'appropriations') {
                        return "$" + Math.round(d/1000000) + "M"
                      } else if (metric_type == 'tuition') {
                        return "$" + Math.round(d/1000) + "K"
                      } else if (metric_type == 'retention') {
                        return d + "%"
                      } else if (metric_type == 'endowment' || metric_type == 'tuition_instruction') {
                        return d*100 + "%"
                      } else {
                        return d;
                      }          
                    }        
                   }).tickSize(0);


  var xline = d3.axisBottom().scale(x).tickValues([]).tickSizeOuter(0);

    var alert = (function(type) {
      if (level == 1) {
        switch(type) {
            case 'appropriations':
              return healthMetrics[0].metric*0.828874818;
            case 'enrollment':
              return healthMetrics[0].metric*0.78365419;
            case 'retention':
              return 65.0;
            case 'tuition':
              return healthMetrics[0].metric;
            case 'endowment':
              return 0;
            case 'revenueVsCost':
              return 0;
            default:
              return 0;
          }
      } else if (level == 2) {
        switch(type) {
            case 'appropriations':
              return healthMetrics[0].metric*.778;
            case 'enrollment':
              return healthMetrics[0].metric*0.80245098;
            case 'retention':
              return 64.0;
            case 'tuition':
              return healthMetrics[0].metric * 0.917602169;
            case 'endowment':
              return healthMetrics[0].metric*1;
            case 'revenueVsCost':
              return 0;
            default:
              return 0;
          }
      } else if (level == 4) {
        switch(type) {
            case 'appropriations':
              return healthMetrics[0].metric*0.882982605;
            case 'enrollment':
              return healthMetrics[0].metric*0.678624813;
            case 'retention':
              return 62.0;
            case 'tuition':
              return healthMetrics[0].metric * .892;
            case 'endowment':
              return healthMetrics[0].metric*.9787;
            case 'tuition_instruction':
              return healthMetrics[0].metric*0.777226559;
            default:
              return 0;
          }
      }
    })(metric_type);

    var warning = (function(type) {
      if (level == 1) {
        switch(type) {
            case 'appropriations':
              return healthMetrics[0].metric*0.716403343;
            case 'enrollment':
              return healthMetrics[0].metric*0.648188697;
            case 'retention':
              return 58.0;
            case 'tuition':
              return healthMetrics[0].metric * 0.937455848;
            case 'endowment':
              return 0;
            case 'revenueVsCost':
              return 0;
            default:
              return 0;
          }
      } else if (level == 2) {
        switch(type) {
            case 'appropriations':
              return healthMetrics[0].metric*.778;
            case 'enrollment':
              return healthMetrics[0].metric*0.674443411;
            case 'retention':
              return 55.0;
            case 'tuition':
              return healthMetrics[0].metric * 0.816605796;
            case 'endowment':
              return healthMetrics[0].metric*0.861570456;
            case 'revenueVsCost':
              return 0;
            default:
              return 0;
          }
      } else if (level == 4) {
        switch(type) {
            case 'appropriations':
              return healthMetrics[0].metric*0.816050101;
            case 'enrollment':
              return healthMetrics[0].metric*0.56587473;
            case 'retention':
              return 62.0;
            case 'tuition':
              return healthMetrics[0].metric * .892;
            case 'endowment':
              return healthMetrics[0].metric*.9787;
            case 'tuition_instruction':
              return healthMetrics[0].metric*0.652040461;
            default:
              return 0;
          }
      }
    })(metric_type);

   var headline = (function(type) {
      switch(type) {
        case 'appropriations':
          return 'appropriations';
        case 'enrollment':
          return 'enrollment';
        case 'retention':
          return 'retention';
        case 'tuition':
          return 'average tuition';
        case 'endowment':
          return 'endowment/expenses';
        case 'tuition_instruction':
          return 'tuition/costs';
        case 'appropriations':
          return 'appropriations';
        default:
          return 0;
      }
    })(metric_type);

   var fluffKey = (function(type) {
    if (level == 4) {
      switch(type) {
        case 'enrollment':
          return 'Total entering fall enrollment has';
        case 'tuition_instruction':
          return 'The ratio of revenue from tuition and fees to instructional expenses has';
        case 'appropriations':
          return 'State and local appropriations have'
        default:
          return 0;
        }
      } else {
      switch(type) {
        case 'appropriations':
          return 'State appropriations have';
        case 'enrollment':
          return 'First-time undergraduate enrollment has';
        case 'retention':
          return 'Retention';
        case 'tuition':
          return 'Per-student tuition revenue has';
        case 'endowment':
          return 'The ratio of endowment assets to expenses has';
        case 'tuition_instruction':
          return 'The ratio of tuition and fees to teaching costs has';
        case 'appropriations-cc':
          return 'State and local appropriations have'
        default:
          return 0;
        }
      }
    })(metric_type);

     var fluffKeyEmbed = (function(type) {
    if (level == 4) {
      switch(type) {
        case 'enrollment':
          return 'Total entering fall enrollment is';
        case 'tuition_instruction':
          return 'The ratio of revenue from tuition and fees to instructional expenses is';
        case 'appropriations':
          return 'State and local appropriations are'
        default:
          return 0;
        }
      } else {
      switch(type) {
        case 'appropriations':
          return 'State appropriations are';
        case 'enrollment':
          return 'First-time undergraduate enrollment is';
        case 'retention':
          return 'Retention is';
        case 'tuition':
          return 'Per-student tuition revenue is';
        case 'endowment':
          return 'The ratio of endowment assets to expenses is';
        case 'tuition_instruction':
          return 'The ratio of tuition and fees to teaching costs is';
        case 'appropriations-cc':
          return 'State and local appropriations '
        default:
          return 0;
        }
      }
    })(metric_type);

   $('#metrics-headline-' + target).html(headline)

   const chartSelector = '#' + metric_type + '-metrics-chart';
   const svgSelector = '#metrics-chart-' + target;

    const svg = d3.select(svgSelector)
                .append('svg')
                  .attr("width", width + margin.left + margin.right)
                  .attr("height", height + margin.top + margin.bottom)

    const g = svg.append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    g.append("g")
      .attr("class", "axis")
      .attr("transform", "translate(" + 0 + "," + height + ")")
       .call(xaxis);

    g.append("g")
      .attr("class", "axis")
      .attr("transform", "translate(" + 0 + "," + 0 + ")")
       .call(yaxis);

    const alertEl = g.append("g")
      .attr("class", "alert")
      .attr("transform", "translate(" + 0 + "," + y(alert) + ")")
       .call(xline);

    const warningEl = g.append("g")
      .attr("class", "alarm")
      .attr("transform", "translate(" + 0 + "," + y(warning) + ")")
       .call(xline);

    const warningText = g.append("text")
      .attr("class", "warning")
      .attr("transform", "translate(" + 2 + "," + (y(warning) + 8) + ")")
      .text("Warning")
        .attr("text-anchor", "beginning")
        .attr("font-size", 7)
        .style("text-transform", "uppercase")
        .attr("fill", "rgba(178,34,34, .8)")
        .attr("font-weight", 500)

    const alertText = g.append("text")
      .attr("class", "alert")
      .attr("transform", "translate(" + 2 + "," + (y(alert) - 2) + ")")
      .text("Alert")
        .attr("text-anchor", "beginning")
        .attr("font-size", 7)
        .style("text-transform", "uppercase")
        .style("font-family", "Lato")
        .style("font-weight", 800)
        .attr("fill", "rgb(105, 123, 159)")

  const the_line = g
        .append("line")
        .attr("class","line")
        .style("stroke", "black")
        .style("stroke-width", 2)
        .style("stroke-opacity", .1)
        .attr("x1",x2(10))
        .attr("x2",x2(20))
        .attr("y1",y(linearRegressionLine(10)))
        .attr("y2",y(linearRegressionLine(20)))

     // Draw the line
 const trend = g.selectAll(".trend")
   .data(newTrends)
   .enter()
   .append("g")
   .attr("class", "trend");

 trend.append("path")
   .attr("class", "line")
   .attr("d", (d) => {
     let keepValues = [];
     for(var i = 0; i < d.values.length; i++){
      keepValues.push(d.values[i]);
       }
     return line(keepValues);
   })

   trend
     .style("fill", "#697b9f")
     .style("stroke", '#697b9f')
     .attr("opacity", 1)

  const el_name = "Total expenses";
  
    // Text fluff 
    const directionality = (function() {
      if ((healthMetrics[healthMetrics.length - 1].metric - healthMetrics[0].metric)/healthMetrics[0].metric<0) {
        return " declined";
      } else if ((healthMetrics[healthMetrics.length - 1].metric - healthMetrics[0].metric)/healthMetrics[0].metric > 0){
        return " increased";
      } else {
        return " remained flat";
      }
    })()

    const regPosition = (function() {
      if (metric_type == "retention") {
        if (flags < 1) {
          return "is projected to be outside alert levels in 2019-20";
        } else if (flags == 1) {
          return "is projected to reached the alert level in 2019-20";
        } else if (flags == 2) {
          return "is projected to be below the alert level in 2019-20";
        } else if (flags == 3) {
          return "is projected to be below the warning level in 2019-20";
        }
      } else {
        if (flags < 1) {
          return "is projected to be outside alert levels in 2019-20";
        } else if (flags == 1) {
          return "is projected to be at the alert level in 2019-20";
        } else if (flags == 2) {
          return "is projected to be below the alert level in 2019-20";
        } else if (flags == 3) {
          return "is projected to be below the warning level in 2019-20";
        }
      }
    })()

    const regPositionEmbed = (function() {
      if (metric_type == "retention") {
        if (flags < 1) {
          return " projected to be outside alert levels in 2019-20";
        } else if (flags == 1) {
          return " projected to reached the alert level in 2019-20";
        } else if (flags == 2) {
          return " projected to be below the alert level in 2019-20";
        } else if (flags == 3) {
          return " projected to be below the warning level in 2019-20";
        }
      } else {
        if (flags < 1) {
          return " projected to be outside alert levels in 2019-20";
        } else if (flags == 1) {
          return " projected to be at the alert level in 2019-20";
        } else if (flags == 2) {
          return " projected to be below the alert level in 2019-20";
        } else if (flags == 3) {
          return " projected to be below the warning level in 2019-20";
        }
      }
    })()

    alertEl.style("opacity",()=> {
        if (flags != 2) {
          return 0.2 
        }
      })
    warningEl.style("opacity",()=> {
        if (flags < 3) {
          return 0.2 
        }
      })
    alertText.style("opacity",()=> {
        if (flags != 2) {
          return 0.3
        }
      })
    warningText.style("opacity",()=> {
        if (flags < 3) {
          return 0.3
        }
      })

    var contextTextEmbed = fluffKeyEmbed + regPositionEmbed + "."

    $('#metrics-fluff-container-' + target + '-embed').html(contextTextEmbed)


    var contentText = fluffKey + directionality + " since 2009-10. This metric " + regPosition + "."; 
    if (metric_type != "retention") {
      $('#metrics-fluff-container-' + target).html(contentText)
    } else {
      contentText = "Retention " + regPosition + ". (Retention thresholds are calculated differently from other metrics. View the <a href=\"https:\/\/tuitiontracker.org\/fitness\/methodology.html\">methodology</a> here.)" ;
      $('#metrics-fluff-container-' + target).html(contentText)
    }
 const timeScales = healthMetrics.map(function(name) { return x(name.timescale); });

 } // end rundata

 export default {runData}